import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const Subscription = ({ user }) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');

  useEffect(() => {
    fetchSubscription();
  }, [user]);

  const fetchSubscription = async () => {
    try {
      const { data, error } = await supabase
        .from('user_subscriptions')
        .select('*')
        .eq('user_id', user.id)
        .single();

      if (error) throw error;
      setSubscription(data);
    } catch (error) {
      console.error('Error fetching subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  const upgradeToPremium = async (billingCycle) => {
    setSelectedPlan(billingCycle);
    setShowContactModal(true);
  };

  if (loading) return <div style={{ color: 'white', textAlign: 'center', padding: '20px' }}>Loading...</div>;

  return (
   <div className="subscription-container">
      <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '30px' }}>Subscription</h2>
      
      {subscription?.is_premium ? (
        <div style={{ 
          background: 'linear-gradient(135deg, #28a745, #20c997)', 
          padding: '25px', 
          borderRadius: '15px',
          marginBottom: '30px',
          textAlign: 'center',
          border: '2px solid #28a745'
        }}>
          <h3 style={{ color: 'white', margin: '0 0 15px 0' }}>✨ Premium Active</h3>
          <p style={{ color: 'white', margin: '5px 0' }}>Billing: {subscription.billing_cycle}</p>
          <p style={{ color: 'white', margin: '5px 0' }}>Expires: {new Date(subscription.expires_at).toLocaleDateString()}</p>
        </div>
      ) : (
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.1)', 
          padding: '25px', 
          borderRadius: '15px',
          marginBottom: '30px',
          textAlign: 'center',
          border: '2px solid rgba(255, 255, 255, 0.2)'
        }}>
          <h3 style={{ color: 'white', margin: '0 0 15px 0' }}>Free Plan</h3>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', margin: '5px 0' }}>• 10 likes per day</p>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', margin: '5px 0' }}>• Basic matching</p>
        </div>
      )}

      {!subscription?.is_premium && (
  <div>
    <h3 style={{ color: 'white', textAlign: 'center', marginBottom: '25px' }}>Upgrade to Premium</h3>
    <div className="subscription-plans">
      
      <div className="subscription-plan weekly-plan">
        <h4 style={{ color: 'white', margin: '0 0 15px 0' }}>Weekly Premium</h4>
        <p style={{ fontSize: '28px', fontWeight: 'bold', color: '#007bff', margin: '10px 0' }}>$4.99/week</p>
        <div style={{ 
          background: 'rgba(0, 123, 255, 0.1)', 
          padding: '8px 12px', 
          borderRadius: '8px', 
          marginBottom: '15px' 
        }}>
          <span style={{ color: '#FFD700', fontSize: '16px', fontWeight: '600' }}>🪙 200 coins included</span>
        </div>
        <ul style={{ 
          textAlign: 'left', 
          margin: '20px 0', 
          paddingLeft: '20px',
          color: 'rgba(255, 255, 255, 0.9)',
          lineHeight: '1.6'
        }}>
          <li>🪙 200 coins per week</li>
          <li>💝 Send virtual gifts (up to 200 coins)</li>
          <li>📸 Share photos (1 coin each person)</li>
          <li>👀 See who liked you</li>
          <li>💳 Coin withdrawal eligibility</li>
          <li>⭐ Super likes & profile boost</li>
        </ul>
        <button 
          onClick={() => upgradeToPremium('weekly')}
          style={{
            background: 'linear-gradient(90deg, #007bff, #0056b3)',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '10px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            transition: 'transform 0.2s ease',
            width: '100%'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Choose Weekly
        </button>
      </div>

      <div className="subscription-plan monthly-plan">
        <div style={{
          position: 'absolute',
          top: '-12px',
          right: '20px',
          background: 'linear-gradient(90deg, #28a745, #20c997)',
          color: 'white',
          padding: '6px 12px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '600',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
        }}>
          BEST VALUE
        </div>
        <h4 style={{ color: 'white', margin: '0 0 15px 0' }}>Monthly Premium</h4>
        <p style={{ fontSize: '28px', fontWeight: 'bold', color: '#28a745', margin: '10px 0' }}>$20.00/month</p>
        <div style={{ 
          background: 'rgba(40, 167, 69, 0.1)', 
          padding: '8px 12px', 
          borderRadius: '8px', 
          marginBottom: '15px' 
        }}>
          <span style={{ color: '#FFD700', fontSize: '16px', fontWeight: '600' }}>🪙 1,500 coins included</span>
          <br/>
          <span style={{ color: '#28a745', fontSize: '12px' }}>(1,000 base + 500 bonus)</span>
        </div>
        <ul style={{ 
          textAlign: 'left', 
          margin: '20px 0', 
          paddingLeft: '20px',
          color: 'rgba(255, 255, 255, 0.9)',
          lineHeight: '1.6'
        }}>
          <li>🪙 1,500 coins per month (25% more value!)</li>
          <li>💝 Send virtual gifts (up to 1,500 coins worth)</li>
          <li>📸 Share photos (1 coin each person)</li>
          <li>👀 See who liked you</li>
          <li>💳 Coin withdrawal eligibility</li>
          <li>⭐ Super likes & profile boost</li>
        </ul>
        <button 
          onClick={() => upgradeToPremium('monthly')}
          style={{
            background: 'linear-gradient(90deg, #28a745, #20c997)',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '10px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            transition: 'transform 0.2s ease',
            width: '100%'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Choose Monthly
        </button>
      </div>
    </div>
  </div>
)}

{/* Custom Contact Modal */}
{showContactModal && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1500,
    backdropFilter: 'blur(10px)'
  }}>
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      borderRadius: '20px',
      padding: '30px',
      maxWidth: '400px',
      width: '90%',
      textAlign: 'center',
      border: '2px solid #00E9FF',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)'
    }}>
      <div style={{ fontSize: '48px', marginBottom: '20px' }}>💎</div>
      
      <h3 style={{ 
        color: '#00E9FF', 
        marginBottom: '15px',
        fontSize: '20px'
      }}>
        Premium Upgrade Request
      </h3>
      
      <p style={{ 
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '20px',
        lineHeight: '1.5'
      }}>
        To upgrade to <strong style={{ color: '#00E9FF' }}>{selectedPlan} Premium</strong>, please contact our customer service team.
      </p>
      
      <div style={{
        background: 'rgba(0, 233, 255, 0.1)',
        borderRadius: '12px',
        padding: '15px',
        marginBottom: '25px',
        border: '1px solid rgba(0, 233, 255, 0.3)'
      }}>
        <p style={{ 
          color: '#00E9FF',
          fontSize: '18px',
          fontWeight: '600',
          margin: 0
        }}>
          📧 hello@flirteen.com
        </p>
      </div>
      
      <button
        onClick={() => setShowContactModal(false)}
        style={{
          background: 'linear-gradient(90deg, #00E9FF, #8A2BE2)',
          color: 'white',
          border: 'none',
          padding: '12px 30px',
          borderRadius: '10px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'transform 0.2s ease'
        }}
        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
      >
        Got it!
      </button>
    </div>
  </div>
)}
    </div>
  );
};

export default Subscription;